import { useEffect, useState } from "react";
import _ from "lodash";
import { Col, Modal, Row } from "react-bootstrap";
import { catalogByPart } from "../../../apis";
import { CatalogueInput } from "../../JSONForms/PreviewForm/CatalogueInput";
import { MCButton } from "../../MainComponents/Button/Button";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fillIfIsCatalogue } from "../../JSONForms/PreviewForm/formStarter";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import { EGSwitch } from "../../MainComponents/Switch/Switch";
import { EGBasicSelect } from "../../MainComponents/Select/EGBasicSelect";
import { EGIconButton } from "../../MainComponents/Button/IconButton/IconButton";

const selectAllPrefix = "type::*";

const EveryValue = ({
  value,
  catalogueInit,
  catDataInit,
  onChange = () => {},
}) => {
  const [catalogue, setCatalogue] = useState(catalogueInit);
  const [catData, setCatData] = useState(catDataInit);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (value && catalogueInit && catDataInit) {
      setIsLoading(true);
      const newData = _.cloneDeep(catDataInit);
      _.set(newData, `0.${newData[0]?.catalogue}`, value);
      fillIfIsCatalogue(catalogueInit, newData).then((resp) => {
        setCatalogue(resp);
        setCatData(newData);
        setIsLoading(false);
      });
    } else {
      setCatalogue(catalogueInit);
      setCatData(catDataInit);
      setIsLoading(false);
    }
  }, [catalogueInit, catDataInit]);

  useEffect(() => {
    if (catalogue && catData) {
      onChange(catData[0][catalogue[0].catalogue], catalogue[0].label);
    }
  }, [catalogue, catData]);

  return (
    <div>
      {isLoading ? (
        <Box sx={{ display: "grid", placeContent: "center", marginBottom: 1 }}>
          <CircularProgress />
        </Box>
      ) : (
        catalogue &&
        catData && (
          <Row className="catalogue-container-single">
            <CatalogueInput
              schema={catalogue[0]}
              scope={catalogue[0]}
              value={catData[0][catalogue[0].catalogue]}
              catalogue={catalogue[0].catalogue}
              isOwn={catalogue[0].isOwn}
              entireSchema={catalogue}
              entireFormData={catData}
              setSchemaState={setCatalogue}
              setFormData={setCatData}
              pathSchema={"0"}
              pathData={"0"}
              returnValidClass={() => {}}
              handleValidate={() => {}}
            />
          </Row>
        )
      )}
    </div>
  );
};

export const ModalSegmentCatalogue = ({
  show,
  onHide,
  scope,
  path,
  handleAddChild,
  handleEditValues,
  utilitiesCatalogues,
  target = "add", // add | edit
}) => {
  const { gTheme } = useSelector((state) => state.theme);
  const [t] = useTranslation("users");

  const [selectedCatalogue, setSelectedCatalogue] = useState(null);
  const [catalogue, setCatalogue] = useState(null);
  const [catData, setCatData] = useState(null);
  const [values, setValues] = useState([]); // Array de objetos { _id, value }
  const [isLoading, setIsLoading] = useState(true);
  const [catalogueInUtilities, setCatalogueInUtilities] = useState(true);
  const [selectAll, setSelectAll] = useState(
    Array.isArray(scope?.value) &&
      scope.value.length === 1 &&
      scope.value[0] === selectAllPrefix &&
      target === "edit"
      ? true
      : false,
  );
  const [expandedAccordions, setExpandedAccordions] = useState({});
  const [catalogueStatesMap, setCatalogueStatesMap] = useState({});

  const generateId = () =>
    `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  // const location = useLocation();

  // --- NUEVO useEffect solo para monitorear ---
  useEffect(() => {
    if (catalogue) {
    }
  }, [catalogue, selectAll]);

  useEffect(() => {
    if (target === "edit") {
      const splitedField = scope?.field?.split("::");
      const catalogue = splitedField[splitedField.length - 1];
      const catalogueInUtilities = utilitiesCatalogues.find(
        (item) => item.catalogue === catalogue,
      );
      setSelectedCatalogue(catalogueInUtilities ?? null);
      setCatalogueInUtilities(!!catalogueInUtilities);
      if (selectAll) {
        setValues([]);
      } else {
        // Convertir array de strings a array de objetos con _id
        const existingValues = catalogueInUtilities ? scope?.value : [];
        const valuesWithIds = Array.isArray(existingValues)
          ? existingValues.map((v) => ({ _id: generateId(), value: v }))
          : [];
        setValues(valuesWithIds);
      }
    } else {
      setValues([]);
    }
  }, []);

  useEffect(() => {
    if (selectedCatalogue) {
      setCatalogue(null);
      setCatData(null);

      buildCatalogueAndData(selectedCatalogue)
        .then(({ catalogue, data }) => {
          if (selectAll) {
            setCatalogue({ [catalogue.key]: catalogue });
          } else {
            setCatalogue([catalogue]);
          }
          setCatData([data]);
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setCatalogue(null);
      setCatData(null);
    }
  }, [selectedCatalogue]);

  const getCatalogueEntry = () => {
    if (Array.isArray(catalogue)) return catalogue[0];
    return Object.values(catalogue)[0];
  };

  const handleSelectAll = () => {
    if (!catalogue) return;
    setSelectAll(true);
  };

  const handleRemoveSelectAll = () => {
    setSelectAll(false);
  };

  // initialize values #EDITION
  const buildCatalogueAndData = async (selectedCatalogue) => {
    const resp = await catalogByPart({
      is_own: selectedCatalogue.isOwn,
      catalogue: selectedCatalogue.catalogue,
      path: "/",
    });

    let children = [...resp.data];
    let objCatalogue = {
      key: `C::${selectedCatalogue.isOwn ? "OWN" : "EG"}::${selectedCatalogue.catalogue}`,
      type: "catalog-select",
      label: selectedCatalogue.label,
      placeholder: t("segmentEdit.support_text"),
      required: false,
      sensitive: false,
      scope: "/",
      selected: "",
      isOwn: selectedCatalogue.isOwn,
      catalogue: selectedCatalogue.catalogue,
      children: children,
    };
    let objCatData = {
      [selectedCatalogue.catalogue]: "",
      catalogue: selectedCatalogue.catalogue,
      isOwn: selectedCatalogue.isOwn,
      sensitive: false,
    };
    return { catalogue: objCatalogue, data: objCatData };
  };

  const handleCatalogueChange = (e) => {
    const selectedKey = e.target.value;
    const selectedObj = utilitiesCatalogues.find(
      (item) => item.key === selectedKey,
    );

    // Guardar estado actual antes de cambiar
    if (selectedCatalogue) {
      setCatalogueStatesMap((prev) => ({
        ...prev,
        [selectedCatalogue.key]: { selectAll, values },
      }));
    }

    // Restaurar estado guardado o reiniciar
    const savedState = catalogueStatesMap[selectedKey];
    if (savedState) {
      setSelectAll(savedState.selectAll);
      setValues(savedState.values);
    } else {
      setSelectAll(false);
      setValues([]);
    }

    setSelectedCatalogue(selectedObj);
  };

  const handleValues = (val, label, id) => {
    if (val) {
      setValues((prev) =>
        prev.map((item) => (item._id === id ? { ...item, value: val } : item)),
      );
    }
  };

  const handleDeleteValue = (id) => {
    setValues((prev) => prev.filter((item) => item._id !== id));
  };

  const handleAccordionToggle = (id) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleAddValue = () => {
    setValues((prev) => [...prev, { _id: generateId(), value: "" }]);
  };

  const handleAddChildLocal = () => {
    const entry = getCatalogueEntry();
    const child = {
      child: null,
      field: entry.key,
      value: selectAll
        ? [selectAllPrefix]
        : [...new Set(values.map((v) => v.value).filter((str) => str !== ""))],
      label: entry.label,
    };
    handleAddChild(path, child);
    onHide();
  };

  const handleEditValuesLocal = () => {
    const cleanedValues = [
      ...new Set(values.map((v) => v.value).filter((str) => str !== "")),
    ];
    const entry = getCatalogueEntry();
    const child = {
      child: scope.child,
      field: entry.key,
      value: selectAll ? [selectAllPrefix] : cleanedValues,
      label: entry.label,
    };
    handleEditValues(path, child);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      className={`${gTheme !== "light" ? "dark-mode" : ""} `}
      centered
      scrollable
    >
      <Modal.Header
        // closeButton
        className={`${gTheme !== "light" ? "btn-close-white" : ""} border-0 d-flex justify-content-between`}
      >
        <Modal.Title>
          {target === "edit"
            ? t("segmentEdit.edit_values")
            : t("segmentCatalogue.add_segment")}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {utilitiesCatalogues && catalogueInUtilities ? (
          <div className="py-2 pt-2 d-flex flex-column flex-md-row align-items-md-center">
            <EGBasicSelect
              options={utilitiesCatalogues}
              value={selectedCatalogue?.key ?? ""}
              onChange={handleCatalogueChange}
              optionLabel="label"
              optionValue="key"
            />
          </div>
        ) : (
          <h6>No se encontro el catalogo en el formulario</h6>
        )}

        <Row>
          {Array.isArray(values) &&
            !selectAll &&
            values.map((item, idx) => (
              <Col sm={12} md={6} lg={4} key={item._id} className="pb-2">
                <Accordion
                  expanded={expandedAccordions[item._id] || false}
                  onChange={() => handleAccordionToggle(item._id)}
                  className="dyTheme1 dyBorder1"
                  sx={{
                    "&:before": { display: "none" },
                    boxShadow: "none",
                    borderRadius: "8px !important",
                  }}
                >
                  <AccordionSummary
                    sx={{
                      minHeight: "48px",
                      "& .MuiAccordionSummary-content": {
                        margin: "8px 0",
                        alignItems: "center",
                        justifyContent: "space-between",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <EGIconButton
                          iconName={
                            expandedAccordions[item._id]
                              ? "arrow_up_3"
                              : "arrow_down_2"
                          }
                        />
                        <Typography variant="body2">
                          {t("segmentCatalogue.filter")} {idx + 1}
                        </Typography>
                      </Box>
                      <EGIconButton
                        iconName="trash_can"
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteValue(item._id);
                        }}
                      />
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ pt: 0 }}>
                    <EveryValue
                      value={item.value}
                      catalogueInit={catalogue}
                      catDataInit={catData}
                      onChange={(val, label) =>
                        handleValues(val, label, item._id)
                      }
                    />
                  </AccordionDetails>
                </Accordion>
              </Col>
            ))}
        </Row>

        {selectAll && (
          <Box
            sx={{ display: "grid", placeContent: "center", marginBottom: 2 }}
          >
            <Typography variant="body1" sx={{ mb: 1 }}>
              {t("segmentCatalogue.all_filters_applied")}
            </Typography>
            <MCButton
              label={t("segmentCatalogue.remove_all_filters")}
              variant="danger"
              outline
              onClick={handleRemoveSelectAll}
            />
          </Box>
        )}

        <div className="d-flex justify-content-end">
          <MCButton
            label={t("segmentCatalogue.cancel")}
            variant="danger"
            outline
            className="me-2"
            onClick={onHide}
          />
          {selectedCatalogue && !selectAll && (
            <MCButton
              label={t("segmentCatalogue.all_filters")}
              variant="primary"
              outline
              className="me-2"
              onClick={handleSelectAll}
              disabled={!selectedCatalogue || selectAll}
            />
          )}
          {selectedCatalogue && !selectAll && (
            <MCButton
              label={t("segmentCatalogue.add_filter")}
              variant="primary"
              outline
              className="me-2"
              onClick={handleAddValue}
            />
          )}
          <MCButton
            label={t("segmentCatalogue.save")}
            variant="success"
            outline
            onClick={
              target === "edit" ? handleEditValuesLocal : handleAddChildLocal
            }
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};
